<template>
	<div>
		<CHeader :pHeaderProps="HeaderProps">
			<template slot="Contenido">
				<div class="row mt-3">
                    <div class="col-12 col-sm-12">
                        <!-- <label for="">Reemplazo Refacción</label><small> (max 1500 caracteres)</small>
                        <textarea class="form-control shadow" cols="30" rows="10" maxlength="1500" v-model="ReemplazoRefaccion" placeholder="Escriba aquí sus observaciones"></textarea> -->
						<button @click="AddRefaccion" type="button" class="btn btn-01"><i class="fa fa-plus-circle"></i> Agregar refacción</button>
					</div>
                </div>
				<div class="row mt-3" v-for="(item,index) in ListaRefacciones" :key="index">
					<div class="col-10">
						<input placeholder="Refacción" type="text" v-model="ListaRefacciones[index]" class="form-control"/>
					</div>
					<div class="col-2">
						<button @click="BorrarRefaccion(Index)" type="button" class="btn-icon-02"><i class="fa fa-trash"></i></button>
					</div>
				</div>
				<div class="row mt-3 justify-content-center">
					<div class="col-10 col-sm-10 text-center">
                        <button :disabled="DisabledBtn" @click="Guardar" type="button" class="btn btn-01 btn-block btn-grande">
                            <i v-show="DisabledBtn" class="fa fa-spinner fa-pulse fa-fw"></i> Guardar
                            <!-- <i v-show="!DisabledBtn" class="fa fa-check"></i> -->
                        </button>
                    </div>
				</div>
			</template>
		</CHeader>
	</div>
</template>

<script>
import CHeader from "@/views/webapp/components/HeaderWebApp.vue";
export default {
	props:['pEquipo','pServicio'],
	components:{CHeader},
	data() {
		return {
			DisabledBtn:false,
			HeaderProps:{
                ShowSubHeader:true,
                ShowTecnico:false,
                ShowFechaHoy:false,
                ShowMenuDropdown:false,
                ShowFotoPerfil:false,
                ShowReturn:true,
                TextoHeader:'Reemplazo Refacción',
                ShowLogo:false,
                TextoCentroSubHeader:''
            },
			Equipo:{},
            Servicio:{},
            ReemplazoRefaccion:'',
			ListaRefacciones:[]
		}
	},
	methods: {
		Guardar(){
			this.DisabledBtn=true;
            let formData=new FormData();
            formData.set('IdServicio',this.Servicio.IdServicio);
            formData.set('ListaRefacciones',JSON.stringify(this.ListaRefacciones));
			formData.set('IdEquipo',this.Equipo.IdEquipo);
			this.$http.post('webapp/reemplazorefaccionpost',formData
            ).then((res)=>{
                this.DisabledBtn=false;
                this.$toast.success('Observación Guardada');
                // this.$router.push({name:'EquiposServicioWebApp'});
            }).catch((err)=>{
                this.DisabledBtn=false;
                this.$toast.warning(err.response.data.message);
            });
		},
		Recuperar(){
			if (this.ReemplazoRefaccion!='' && this.ReemplazoRefaccion!=null) {
				let ReemplazoRefaccion=this.ReemplazoRefaccion.replace(/⦁/g, '');
				let Refacciones=ReemplazoRefaccion.split("\r\n");
				this.ListaRefacciones=Refacciones.map((value) => {
					let Caracter=value.replace(/^\s+/g, '');
					if (Caracter[Caracter.length-1] === ".") {
						Caracter = Caracter.slice(0,-1);
					}
					return Caracter;
				});
			}
		},
		Regresar(){
            this.$router.push({name:'EquiposServicioWebApp'});
        },
		AddRefaccion(){
			this.ListaRefacciones.push('');
		},
		BorrarRefaccion(Index){
			this.ListaRefacciones.splice(Index,1);
		}
	},
	mounted() {
		this.bus.$off('EmitReturn');
        this.bus.$on('EmitReturn',()=>{
            this.Regresar();
        });
        this.Servicio=this.pServicio;
		this.Equipo=this.pEquipo;
		this.HeaderProps.TextoCentroSubHeader=this.Equipo.Nequipo;
		this.ReemplazoRefaccion=this.Equipo.ReemplazoRefaccion;
		this.Recuperar();
	},
}
</script>

<style>

</style>
